import React, { Component, PropTypes } from 'react';
import Dropdown from 'common/components/Dropdown';
import ResourceCard from 'common/components/ResourceCard';
import { staticIconUrlPNG } from '../../reducers/point';
import cx from 'classnames';

const ICONS = [
  {
    code: 'question',
    icon: 'interogation',
    label: 'Question',
  },
  {
    code: 'info',
    icon: 'information',
    label: 'Information',
  },
  {
    code: 'exclamation',
    icon: 'exclamation',
    label: 'Avertissement',
  },
  {
    code: 'cone',
    icon: 'works',
    label: 'Travaux',
  },
  {
    code: 'camera',
    icon: 'camera',
    label: 'Photo',
  },
];

const renderDefault = () => <div className="default text">Icône</div>;

const renderItem = item => (
  <div key={item.code} data-value={item.code.toUpperCase()} className="item">
    <img
      src={staticIconUrlPNG(item.icon)}
      alt="Commentaire"
      style={{ marginTop: '0px' }}
    />
    {item.label}
  </div>
);

class CommentForm extends Component {
  render() {
    const { comment, onChangeImage, hasError, disabled } = this.props;

    const resource = comment ? comment.picture : null;

    const iconFieldClass = cx('ui field', {
      error: hasError,
    });

    return (
      <form className="ui form">
        <div className="ui grid">
          <div className="ui five wide column">
            <ResourceCard
              name="photo"
              resource={resource}
              onChange={onChangeImage}
              canDelete={false}
              canUpdate={!disabled}
            />
          </div>
          <div className="ui eleven wide column">
            <div className={iconFieldClass}>
              <label>Icône</label>
              <Dropdown
                name="icon"
                value={comment.icon}
                items={ICONS}
                renderDefault={renderDefault}
                renderItem={renderItem}
                disabled={disabled}
              />
            </div>
            <div className="ui field">
              <label>Commentaire</label>
              <input
                name="name"
                maxLength="250"
                type="text"
                defaultValue={comment.name}
                readOnly={disabled}
              />
            </div>
          </div>
        </div>
      </form>
    );
  }
}

CommentForm.propTypes = {
  comment: PropTypes.object,
  disabled: PropTypes.bool.isRequired,
  onChangeImage: PropTypes.func.isRequired,
};

CommentForm.defaultProps = {
  comment: {},
};

export default CommentForm;



// WEBPACK FOOTER //
// ./src/modules/saas/pco/zones/plan/components/forms/CommentForm.js